export enum StorageKey {
  User = 'user',
  Token = 'token',
  LanguageLocale = 'language-locale',
  RememberedEmail = 'remembered_email',
  LastVisitId = 'last-visit-id'
}
